import { useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { FaEnvelope, FaTimes, FaWhatsapp } from "react-icons/fa";
import { MdChatBubble } from "react-icons/md";
import { Link } from "react-router-dom";
import "./styles.scss";

const optionVariants = {
	hidden: { opacity: 0, y: 16, scale: 0.9 },
	visible: (index) => ({
		opacity: 1,
		y: 0,
		scale: 1,
		transition: { delay: index * 0.05, duration: 0.22, ease: "easeOut" },
	}),
	exit: { opacity: 0, y: 10, scale: 0.92, transition: { duration: 0.16 } },
};

const Burbuja = () => {
	const [isOpen, setIsOpen] = useState(true);
	const shouldReduceMotion = useReducedMotion();

	return (
		<div className="burbujas">
			<AnimatePresence>
				{isOpen ? (
					<>
						<motion.a
							custom={1}
							className="burbuja_option burbuja_wpp"
							href="https://api.whatsapp.com/send?phone=573104477161&text=Hola! me llamo "
							target="_blank"
							rel="noreferrer"
							aria-label="Abrir WhatsApp"
							variants={shouldReduceMotion ? undefined : optionVariants}
							initial={shouldReduceMotion ? false : "hidden"}
							animate="visible"
							exit="exit"
						>
							<FaWhatsapp />
						</motion.a>
						<motion.div
							custom={0}
							variants={shouldReduceMotion ? undefined : optionVariants}
							initial={shouldReduceMotion ? false : "hidden"}
							animate="visible"
							exit="exit"
						>
							<Link
								className="burbuja_option burbuja_email"
								to="/contacto"
								aria-label="Ir a contacto"
								onClick={() => setIsOpen(false)}
							>
								<FaEnvelope />
							</Link>
						</motion.div>
					</>
				) : null}
			</AnimatePresence>

			<motion.button
				type="button"
				className="burbuja"
				onClick={() => setIsOpen((current) => !current)}
				aria-label={isOpen ? "Cerrar opciones de contacto" : "Abrir opciones de contacto"}
				aria-expanded={isOpen}
				animate={shouldReduceMotion ? undefined : { scale: [1, 1.04, 1] }}
				transition={{ duration: 2.8, repeat: Infinity, ease: "easeInOut" }}
			>
				{isOpen ? <FaTimes /> : <MdChatBubble />}
			</motion.button>
		</div>
	);
};

export default Burbuja;
